import React, { useState } from 'react';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import SignaturePad from '../../SignaturePad';
import { PencilSquareIcon, CheckCircleIcon } from '@heroicons/react/24/outline';

const Recapitulatif = ({ formikProps }) => {
  const { values, setFieldValue } = formikProps;
  const [showSignaturePad, setShowSignaturePad] = useState(false);

  const handleSignature = (signatureBase64) => {
    setFieldValue('signature', signatureBase64);
    setShowSignaturePad(false);
  };

  return (
    <div className="space-y-8">
      <div className="text-center mb-6">
        <h3 className="text-lg font-medium leading-6 text-gray-900">
          Récapitulatif de votre demande d'adhésion
        </h3>
        <p className="mt-1 text-sm text-gray-500">
          Veuillez vérifier les informations avant de soumettre votre demande
        </p>
      </div>

      <div className="bg-white shadow overflow-hidden sm:rounded-lg">
        <div className="px-4 py-5 sm:px-6">
          <h3 className="text-lg leading-6 font-medium text-gray-900">Informations personnelles</h3>
        </div>
        <div className="border-t border-gray-200">
          <dl>
            <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">Nom complet</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                {values.informationsPersonnelles.prenom} {values.informationsPersonnelles.nom}
              </dd>
            </div>
            <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">Date de naissance</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                {values.informationsPersonnelles.dateNaissance
                  ? format(new Date(values.informationsPersonnelles.dateNaissance), 'dd MMMM yyyy', { locale: fr })
                  : ''}
              </dd>
            </div>
            <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">Adresse</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                {values.informationsPersonnelles.adresse.rue}
                <br />
                {values.informationsPersonnelles.adresse.codePostal} {values.informationsPersonnelles.adresse.ville}
              </dd>
            </div>
            <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">Téléphone</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                {values.informationsPersonnelles.telephone}
              </dd>
            </div>
            <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">Email</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                {values.informationsPersonnelles.email}
              </dd>
            </div>
          </dl>
        </div>

        <div className="px-4 py-5 sm:px-6">
          <h3 className="text-lg leading-6 font-medium text-gray-900">Informations apicoles</h3>
        </div>
        <div className="border-t border-gray-200">
          <dl>
            <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">Nombre de ruches</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                {values.informationsApicoles.nombreRuches}
              </dd>
            </div>
            <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">Localisation</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                {values.informationsApicoles.localisation.commune}, {values.informationsApicoles.localisation.departement}
              </dd>
            </div>
            {values.informationsApicoles.napi && (
              <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">NAPI</dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                  {values.informationsApicoles.napi}
                </dd>
              </div>
            )}
            {values.informationsApicoles.amexa && (
              <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">AMEXA</dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                  {values.informationsApicoles.amexa}
                </dd>
              </div>
            )}
            {values.informationsApicoles.siret && (
              <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">SIRET</dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                  {values.informationsApicoles.siret}
                </dd>
              </div>
            )}
          </dl>
        </div>
      </div>

      {/* Adhésion AMAIR gratuite (si SAR) */}
      {values.organisme === 'SAR' && values.adhesionAMAIRGratuite && (
        <div className="bg-white shadow overflow-hidden sm:rounded-lg">
          <div className="px-4 py-5 sm:px-6">
            <h3 className="text-lg leading-6 font-medium text-gray-900">Adhésion à l'AMAIR</h3>
          </div>
          <div className="border-t border-gray-200">
            <div className="bg-honey-50 px-4 py-5 sm:px-6">
              <div className="flex items-center">
                <svg className="h-6 w-6 text-honey-600 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <div>
                  <p className="text-sm font-medium text-honey-900">
                    Adhésion gratuite à l'AMAIR incluse
                  </p>
                  <p className="text-xs text-honey-700 mt-1">
                    Votre adhésion à l'AMAIR sera automatiquement créée dès validation de votre adhésion SAR (valeur 50€)
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Cases à cocher obligatoires */}
      <div className="bg-white shadow overflow-hidden sm:rounded-lg">
        <div className="px-4 py-5 sm:px-6">
          <h3 className="text-lg leading-6 font-medium text-gray-900">Attestations obligatoires</h3>
          <p className="mt-1 text-sm text-gray-500">
            Veuillez prendre connaissance des documents suivants et cocher les cases pour continuer
          </p>
        </div>
        <div className="border-t border-gray-200 px-4 py-5 sm:px-6">
          <div className="space-y-4">
            {/* Case à cocher pour les statuts */}
            {values.organisme === 'SAR' && (
            <>
            <div className="flex items-start">
              <div className="flex items-center h-5">
                <input
                  id="acceptStatuts"
                  type="checkbox"
                  checked={values.acceptStatuts || false}
                  onChange={(e) => setFieldValue('acceptStatuts', e.target.checked)}
                  className="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                />
              </div>
              <div className="ml-3 text-sm">
                <label htmlFor="acceptStatuts" className="font-medium text-gray-700">
                  J'atteste avoir pris connaissance des{' '}
                  <a
                    href="/documents/SAR_Statuts.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-indigo-600 hover:text-indigo-800 underline"
                  >
                    statuts
                  </a>
                  {' '}du SAR <span className="text-red-600">*</span>
                </label>
              </div>
            </div>
            <div className="flex items-start">
              <div className="flex items-center h-5">
                <input
                  id="acceptReglementSAR"
                  type="checkbox"
                  checked={values.acceptReglementSAR || false}
                  onChange={(e) => setFieldValue('acceptReglementSAR', e.target.checked)}
                  className="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                />
              </div>
              <div className="ml-3 text-sm">
                <label htmlFor="acceptReglementSAR" className="font-medium text-gray-700">
                  J'atteste avoir pris connaissance du{' '}
                  <a
                    href="/documents/SAR_Reglement-interieur.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-indigo-600 hover:text-indigo-800 underline"
                  >
                    règlement intérieur
                  </a>
                  {' '}du SAR <span className="text-red-600">*</span>
                </label>
              </div>
            </div>
            </>
            )}

            {/* Case à cocher pour les statuts AMAIR (si SAR avec adhésion AMAIR gratuite) */}
            {((values.organisme === 'SAR' && values.adhesionAMAIRGratuite) || values.organisme === 'AMAIR') && (
              <>
              <div className="flex items-start">
                <div className="flex items-center h-5">
                  <input
                    id="acceptStatutsAMAIR"
                    type="checkbox"
                    checked={values.acceptStatutsAMAIR || false}
                    onChange={(e) => setFieldValue('acceptStatutsAMAIR', e.target.checked)}
                    className="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                  />
                </div>
                <div className="ml-3 text-sm">
                  <label htmlFor="acceptStatutsAMAIR" className="font-medium text-gray-700">
                    J'atteste avoir pris connaissance des{' '}
                    <a
                      href="/documents/AMAIR_Statuts.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-indigo-600 hover:text-indigo-800 underline"
                    >
                      statuts</a>{' '}
                    de {values.organisme === 'SAR' ? 'l\'AMAIR' : 'l\'association'}
                    {' '}<span className="text-red-600">*</span>
                  </label>
                </div>
              </div>
              <div className="flex items-start">
                <div className="flex items-center h-5">
                  <input
                    id="acceptReglementAMAIR"
                    type="checkbox"
                    checked={values.acceptReglementAMAIR || false}
                    onChange={(e) => setFieldValue('acceptReglementAMAIR', e.target.checked)}
                    className="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                  />
                </div>
                <div className="ml-3 text-sm">
                  <label htmlFor="acceptReglementAMAIR" className="font-medium text-gray-700">
                    J'atteste avoir pris connaissance du{' '}
                    <a
                      href="/documents/AMAIR_Reglement-interieur.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-indigo-600 hover:text-indigo-800 underline"
                    >
                      règlement intérieur
                    </a>{' '}
                    de {values.organisme === 'SAR' ? 'l\'AMAIR' : 'l\'association'}
                    {' '}<span className="text-red-600">*</span>
                  </label>
                </div>
              </div>
            </>
            )}

            {/* Case à cocher pour les conditions générales */}
            <div className="flex items-start">
              <div className="flex items-center h-5">
                <input
                  id="acceptConditions"
                  type="checkbox"
                  checked={values.acceptConditions || false}
                  onChange={(e) => setFieldValue('acceptConditions', e.target.checked)}
                  className="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                />
              </div>
              <div className="ml-3 text-sm">
                <label htmlFor="acceptConditions" className="font-medium text-gray-700">
                  J'atteste avoir pris connaissance{' '}
                  <a
                    href="/cgu"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-indigo-600 hover:text-indigo-800 underline"
                  >
                    de la charte d'utilisation de la plateforme,
                  </a>{' '}
                  <a
                    href="/cgv"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-indigo-600 hover:text-indigo-800 underline"
                  >
                    des conditions générales de vente
                  </a>{' '}
                  <a
                    href="/politique-confidentialite"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-indigo-600 hover:text-indigo-800 underline"
                  >
                    et de la politique de confidentialité
                  </a>{' '}de la plateforme
                  {' '}<span className="text-red-600">*</span>
                </label>
              </div>
            </div>

            {/* Message d'erreur si non cochées */}
            {((values.organisme === 'SAR' && (!values.acceptStatuts || !values.acceptReglementSAR)) ||
              !values.acceptConditions ||
              ((values.organisme === 'SAR' && values.adhesionAMAIRGratuite) && (!values.acceptStatutsAMAIR || !values.acceptReglementAMAIR)) ||
              (values.organisme === 'AMAIR' && (!values.acceptStatutsAMAIR || !values.acceptReglementAMAIR))) && (
              <div className="mt-2 text-sm text-red-600">
                * Ces attestations sont obligatoires pour soumettre votre demande d'adhésion
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Module de signature */}
      <div className="bg-white shadow overflow-hidden sm:rounded-lg">
        <div className="px-4 py-5 sm:px-6">
          <h3 className="text-lg leading-6 font-medium text-gray-900">Signature numérique</h3>
          <p className="mt-1 text-sm text-gray-500">
            Signez numériquement votre demande d'adhésion
          </p>
        </div>
        <div className="border-t border-gray-200 px-4 py-5 sm:px-6">
          {values.signature ? (
            <div className="space-y-4">
              <div className="flex items-center justify-between p-4 border border-green-200 bg-green-50 rounded-lg">
                <div className="flex items-center">
                  <CheckCircleIcon className="h-6 w-6 text-green-600 mr-3" />
                  <div>
                    <p className="text-sm font-medium text-green-900">
                      Signature enregistrée
                    </p>
                    <p className="text-xs text-green-700">
                      Vous pouvez modifier votre signature si nécessaire
                    </p>
                  </div>
                </div>
                <button
                  type="button"
                  onClick={() => setShowSignaturePad(true)}
                  className="px-4 py-2 text-sm font-medium text-green-700 bg-white border border-green-300 rounded-md hover:bg-green-50 transition-colors"
                >
                  Modifier
                </button>
              </div>
              <div className="border border-gray-200 rounded-lg p-4 bg-white">
                <img 
                  src={values.signature} 
                  alt="Signature" 
                  className="max-w-full h-auto mx-auto"
                  style={{ maxHeight: '150px' }}
                />
              </div>
            </div>
          ) : (
            <div className="text-center py-8">
              <PencilSquareIcon className="h-12 w-12 text-gray-400 mx-auto mb-4" />
              <p className="text-gray-600 mb-4">
                Veuillez signer électroniquement votre demande d'adhésion
              </p>
              <button
                type="button"
                onClick={() => setShowSignaturePad(true)}
                className="px-6 py-3 bg-indigo-600 text-white font-medium rounded-lg hover:bg-indigo-700 transition-colors"
              >
                Signer maintenant
              </button>
              <p className="mt-2 text-xs text-red-600">
                * La signature est obligatoire pour soumettre votre demande
              </p>
            </div>
          )}
        </div>
      </div>

      <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4">
        <div className="flex">
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-yellow-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
          </div>
          <div className="ml-3">
            <p className="text-sm text-yellow-700">
              En soumettant ce formulaire, vous certifiez que les informations fournies sont exactes.
            </p>
          </div>
        </div>
      </div>

      {/* Modal de signature */}
      {showSignaturePad && (
        <SignaturePad
          onSave={handleSignature}
          onCancel={() => setShowSignaturePad(false)}
        />
      )}
    </div>
  );
};

export default Recapitulatif;
